import React, { useEffect, useState } from 'react';
import {
  TextField,
  Box,
  Grid,
  Typography,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider,
  IconButton,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import { observer } from 'mobx-react';

import { useStore } from '@roc/client-portal-shared/hooks';

export const AssignCadenceTemplateModal = observer(({selectedCadenceId}) => {
  const [allOwners, setAllOwners] = useState([]);
  const { salesforceLeadStore, cadenceStore } = useStore();

  const selectedUsers = cadenceStore.cadenceSelectedUsers;

const fetchData = async () => {
  await salesforceLeadStore.getAllOwners();
  const activeOwners = salesforceLeadStore.owners.filter((owner) => owner.active);
  setAllOwners(activeOwners);

  await cadenceStore.fetchOriginatorsAssociatedWithCadence(selectedCadenceId);
  const matchedUsers = activeOwners.filter((owner) =>
    cadenceStore.backOfficeAssociated.includes(owner.userId)
  );

  cadenceStore.settingCadenceAssignedUsers(matchedUsers);
};

  useEffect(() => {
    fetchData();
  }, []);

  const availableOptions = allOwners
    .filter((owner) => !selectedUsers.find((user) => user.userId === owner.userId))
    .sort((a, b) => {
      const getGroup = (email) => {
        if (email.includes('civicfs')) return 'Civic';
        if (email.includes('faco')) return 'Faco';
        if (email.includes('roc')) return 'Roc';
        return 'Other';
      };
      return getGroup(a.userName).localeCompare(getGroup(b.userName));
    });

  const handleRemoveUser = (userId) => {
    const updated = selectedUsers.filter((user) => user.userId !== userId);
    cadenceStore.settingCadenceAssignedUsers(updated);
  };

  const handleAddUser = (event, newValue) => {
    if (newValue && !selectedUsers.find((user) => user.userId === newValue.userId)) {
      cadenceStore.settingCadenceAssignedUsers([...selectedUsers, newValue]);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box p={2}>
          <Autocomplete
            options={availableOptions}
            getOptionLabel={(option) => `${option.firstName} ${option.lastName} (${option.userName})`}
            onChange={handleAddUser}
            renderTags={() => null}
            groupBy={(option) => {
              const domain = option.userName.split('@')[1];
              if (domain.includes('civicfs')) return 'Civic';
              if (domain.includes('faco')) return 'Faco';
              if (domain.includes('roc')) return 'Roc';
              return 'Other';
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Share Cadence with:"
                placeholder="Search originators..."
              />
            )}
          />
        </Box>
      </Grid>

      {selectedUsers.length > 0 && (
        <Grid item xs={12}>
          <Box p={2} border={1} borderColor="grey.300" borderRadius={4}>
            <Typography variant="subtitle1" gutterBottom>
              Shared With:
            </Typography>
            <List style={{ maxHeight: '200px', overflowY: 'auto' }}>
              {selectedUsers
                .slice()
                .sort((a, b) => a.firstName.localeCompare(b.firstName))
                .map((user, index) => (
                  <React.Fragment key={user.userId}>
                    <ListItem dense>
                      <ListItemAvatar>
                        <Avatar style={{ width: 28, height: 28, fontSize: '0.8rem' }}>
                          {user.firstName.charAt(0).toUpperCase()}
                          {user.lastName.charAt(0).toUpperCase()}
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          <Typography variant="body2" style={{ lineHeight: 1.2 }}>
                            {user.firstName} {user.lastName}
                          </Typography>
                        }
                        secondary={
                          <Typography variant="caption" color="textSecondary" style={{ lineHeight: 1.2 }}>
                            {user.userName}
                          </Typography>
                        }
                      />
                      <IconButton
                        size="small"
                        onClick={() => handleRemoveUser(user.userId)}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </ListItem>
                    {index < selectedUsers.length - 1 && <Divider />}
                  </React.Fragment>
                ))}
            </List>
          </Box>
        </Grid>
      )}
    </Grid>
  );
});
